import moment from 'moment';

export default class ContractOwnershipList {
    agreementType: string;
    ownershipId: number;
    agreementId: number;
    agreementholdId: number;
    agreementNumber: string;
    book: string;
    page: string;
    instrumentNumber: string;
    agreementDate: Date;
    originalLessor: string;
    originalLessee: string;
    isInHand?: boolean;
    isGeneratedAgreement?: boolean;
    isActiveLease?: boolean;
    isTopLease?: boolean;

    // TODO: Lease Number will be deprecated when ContractLookup is fully in use.
    leaseNumber: string;

    public static cleanDates(leaseholds: Array<ContractOwnershipList>) {
        leaseholds.map((lm: ContractOwnershipList) => {
            if (lm?.agreementDate) {
                lm.agreementDate = moment(lm.agreementDate).format('YYYY-MM-DD') as unknown as Date;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/models/ContractOwnershipList.ts